import { useState } from "react";

import { DESFAZER_MENSAGEM, DESFAZER_TITULO } from "@/modules/recursos/simulacao";
import type {
  DesfazerAlteracaoProps,
  DesfazerAlteracaoViewModel,
} from "./types-desfazer-alteracao";

export function useDesfazerAlteracao({
  onDesfazer,
  testId,
}: DesfazerAlteracaoProps): DesfazerAlteracaoViewModel {
  const [confirmando, setConfirmando] = useState(false);

  return {
    testId,
    confirmando,
    titulo: DESFAZER_TITULO,
    mensagem: DESFAZER_MENSAGEM,
    confirmarLabel: DESFAZER_TITULO.replace("?", ""),
    pedirConfirmacao: () => setConfirmando(true),
    confirmar: () => {
      setConfirmando(false);
      onDesfazer();
    },
    cancelar: () => setConfirmando(false),
  };
}
